module.exports = __webpack_public_path__ + "img/todov3.379a6f52.png";